import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import isLocalhost from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root"));
//RC - `create-reac-app` expects `service-worker.js` to be at the root URL, and this is not.
//I haven't fixed that yet, so I'm not using service worker in JBoss at the moment (2018-12-17)
if (isLocalhost && document.URL.includes(":3000")) {
	registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js